<template>
  <div class="h-full media-width">
    <div v-if="isEmptyUnsigned && isDesktop" class="bg--neutro70">
      <div class="bg-white flex items-center py-12 px-10">
        <UnsignedEmpty />
        <div class="pl-10">
          <p class="main--title-empty pb-3">{{ $t('message.myTeam.notFound.title') }}</p>
          <p class="main--subtitle-empty pb-3">
            {{ $t('message.myTeam.noFiles') }}
          </p>
          <p class="main--comment-empty">
            {{ $t('message.myTeam.signedDocuments') }}
          </p>
        </div>
      </div>
    </div>
    <template v-else>
      <div v-if="isAIDocument" class="flex justify-end mb-2 mr-4">
        <zt-button outlined @click="activeAI = true" icon="AIRobot"> {{ $t("message.virtualAssistantAI.title")
          }}</zt-button>
      </div>
      <AIHelper v-if="activeAI" :AIQuestions="AIQuestions" :documentId="document.id" @close="activeAI = false"
        :sendTermsAndConditions="sendTermsAndConditions" />

      <template v-if="isEform">
        <DocumentDetailEform />
      </template>
      <template v-else>

        <div class="detail--container lg:h-auto">
          <DocumentDetailHeader class="order-2 lg:order-none"
            :class="{ 'document-detail-header--fullscreen': isFullScreen, }" @set-page="setActualPage" @zoom-in="zoomIn"
            @zoom-out="zoomOut" @fullscreen-change="setFullScreen" :page="page" />
          <DocumentVisualizer ref="pdfVisualizer" class="order-1"
            :class="{ 'document-visualizer--fullscreen': isFullScreen }" :page="page" :full-screen="isFullScreen" />
        </div>
      </template>
    </template>
  </div>
</template>
<script>

import UnsignedEmpty from './SVG/UnsignedEmpty'
import DocumentDetailHeader from './DocumentDetailHeader'
import DocumentVisualizer from './DocumentVisualizer'
import DocumentDetailEform from './DocumentDetailEform'
import { mapState, mapGetters } from 'vuex'
import { includes, isEmpty } from 'lodash'
import { useWindowResize } from '@sichern/ui-elements'
import AIHelper from './AIHelper.vue'
import AI from '@/apiClient/AI.js'

export default {
  name: 'DocumentDetail',
  components: {
    DocumentDetailHeader,
    DocumentVisualizer,
    DocumentDetailEform,
    UnsignedEmpty,
    AIHelper
  },
  provide() {
    return {
      zoomIn: this.zoomIn,
      zoomOut: this.zoomOut
    }
  },
  data() {
    return {
      page: 1,
      windowSize: useWindowResize(this),
      activeAI: false,
      AIQuestions: [],
      isFullScreen: false,
    }
  },
  methods: {
    permissionOnButton(id) {
      const actions = this.$store.state.actions;
      return actions && actions.length > 0 ? actions.some(act => act.id === id) : false;
    },
    async getInitialAIConfig() {
      if (this.permissionOnButton('300')) {
        const hasAcceptedAITermsAndConditions = this.$store.state.hasAcceptedAITermsAndConditions
        Object.keys(hasAcceptedAITermsAndConditions).length !== 0 ? await this.getQuestionVismi() : this.getTermsAndCondition()
      }
    },
    async getTermsAndCondition() {
      const response = await this.AI.getTermsAndCondition();
      const { data } = response.data
      if (data.confirm === '1') {
        await this.getQuestionVismi()
        this.$store.dispatch('setAITermsAndConditions', data)
      }
    },

    async sendTermsAndConditions(termsAndConfigData) {
      try {
        await this.AI.postTermsAndCondition(termsAndConfigData);
        this.$store.dispatch('setAITermsAndConditions', termsAndConfigData);
        await this.getQuestionVismi();
      } catch (error) {
        console.error(this.$t("message.myTeam.errorSend"), error.message);
      }
    },

    async getQuestionVismi() {
      if (this.AIQuestions.length <= 0) {
        try {
          const response = await this.AI.getQuestions();
          this.AIQuestions = response.data.data

        } catch (error) {
          this.AIQuestions = []
        }
      }
    },

    setActualPage(page) {
      this.page = page
    },
    zoomIn() {
      const instance = this.$refs.pdfVisualizer.getInstance()
      instance.zoomIn()
    },
    zoomOut() {
      const instance = this.$refs.pdfVisualizer.getInstance()
      instance.zoomOut()
    },
    async setFullScreen() {
      this.isFullScreen = !this.isFullScreen
    }
  },
  async created() {
    this.AI = new AI();
    this.getInitialAIConfig()
  },
  computed: {
    ...mapGetters('documents', ['getUnsignedDocs']),
    ...mapState('documents', ['document']),
    isEform() {
      return (
        this.document.tipo_formato === 'eform' &&
        !includes(this.document.archivo, 'pdf')
      )
    },
    isEmptyUnsigned() {
      return isEmpty(this.getUnsignedDocs) && isEmpty(this.document)
    },
    isDesktop() {
      return this.windowSize.width > 1024
    },
    isAIDocument() {
      return this.document && this.document.carpeta_ia && this.permissionOnButton('300')
    },
  }
}
</script>
<style scoped>
.detail--container {
  display: block;


}

@media screen and (max-width: 1023px) {
  .detail--container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 150px);
  }
}

@media screen and (min-width: 1024px) and (max-width: 1300px) {
  .media-width {
    width: 68%;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1700px) {
  .media-width {
    width: 86%;
  }
}

.bg--neutro70 {
  background: #707070;
  padding: 30px 50px;
}

.main--title-empty {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;

  color: #575757;
}

.main--subtitle-empty {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #575757;
}

.document-detail-header--fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  max-height: 50px;
  height: 100%;
  z-index: 1003 !important;
}

.document-visualizer--fullscreen {
  position: fixed;
  top: 4%;
  right: 0;
  z-index: 1000;
  height: 100%;
  width: 100%;
}


.main--comment-empty {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #929292;
}
</style>
